export default {
	api: 'https://laundry-uat.ust.hk/ldr/api',
	loginTimeout: 86400
};
